<template>
  <el-dialog :title="title" :visible.sync="visible" :modal-append-to-body="false" append-to-body width="70%">
    <div v-loading="loading">
      <CaseInfoFormAdd ref="caseInfoFormAdd" :disabled="disabled" :openType="openType" :status="status" />
      <!-- 个人当事人信息 -->
      <div class="info-item notarization">
        <div class="header">
          <p class="title">个人当事人信息</p>
          <!-- <el-button type="success" icon="el-icon-plus" size="small" @click="openPartyForm('add')" v-if="showAddBtn">新增个人当事人</el-button> -->
        </div>
        <!-- 表格 -->
        <el-table :data="storePersonList" border stripe style="width: 100%"
          :header-cell-style="{ 'background': '#f5f7fa' }">
          <el-table-column align="center" prop="name" label="姓名" width="80"> </el-table-column>
          <el-table-column align="center" prop="birth" label="出生日期" width="100"> </el-table-column>
          <el-table-column align="center" prop="idCard" label="身份证号码" width="180"> </el-table-column>
          <el-table-column align="center" prop="email" label="邮箱" width="180"> </el-table-column>
          <el-table-column align="center" prop="address" label="地址"> </el-table-column>
          <el-table-column align="center" prop="phone" label="联系电话" width="120"> </el-table-column>
          <el-table-column align="center" fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="openPartyForm('see', scope.$index)" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 公司当事人信息 -->
      <div class="info-item notarization">
        <div class="header">
          <p class="title">企业当事人信息</p>
          <!-- <el-button type="success" icon="el-icon-plus" size="small" @click="openPartyFormCompany('add')" v-if="showAddBtn">新增企业当事人</el-button> -->
        </div>
        <!-- 表格 -->
        <el-table :data="storeCompanyList" border stripe style="width: 100%"
          :header-cell-style="{ 'background': '#f5f7fa' }">
          <el-table-column align="center" prop="companyName" label="公司名称" width="200"> </el-table-column>
          <el-table-column align="center" prop="legalName" label="法人" width="80"> </el-table-column>
          <el-table-column align="center" prop="legalCard" label="法人身份证号码" width="200"> </el-table-column>
          <el-table-column align="center" prop="creditCode" label="社会信用代码" width="200"> </el-table-column>
          <el-table-column align="center" prop="address" label="地址"> </el-table-column>
          <el-table-column align="center" fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="openPartyFormCompany('see', scope.$index)" size="small">查看</el-button>
              <!-- <el-button @click="openPartyFormCompany('edit', scope.$index)" :disabled="disabled" type="primary" size="small">编辑</el-button> -->
              <!-- <el-button @click="deleteParty(scope.row.id, scope.$index)" :disabled="disabled" type="danger" size="small">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 证据材料 -->
      <div class="info-item evidence">
        <div class="header">
          <p class="title">证据材料</p>
          <div>
            <el-button type="success" icon="el-icon-download" size="small" @click="opendown(notaryDocumentList, '1')">打包
            </el-button>
            <el-button type="success" icon="el-icon-plus" size="small" v-show="showAddBtn" @click="openDocUpload()">
              新增证据材料</el-button>
          </div>
        </div>
        <div v-if="status < 5">
          <file-list :fileList="notaryDocumentList" @deleteItemNotDoc="deleteItemNotDoc" :disabled="disabled"
            :openType="openType" />
        </div>
        <div v-else>
          <FlieListNodelete :fileList="notaryDocumentList" @deleteItemNotDoc="deleteItemNotDoc" :disabled="disabled"
            :openType="openType" />
        </div>
      </div>

      <!-- 操作记录 -->
      <div class="info-item">
        <div class="header">
          <p class="title">操作记录</p>
          <el-button type="primary" size="small" @click="openprint()">打印</el-button>
        </div>
        <el-table :data="newWorkFlowList" border stripe style="width: 100%"
          :header-cell-style="{ 'background': '#f5f7fa' }">
          <el-table-column align="center" prop="ownerName" label="操作人"> </el-table-column>
          <el-table-column align="center" prop="status_name" label="案件状态"> </el-table-column>
          <el-table-column align="center" prop="agree" label="是否同意"> </el-table-column>
          <el-table-column align="center" prop="createTime" label="操作时间"> </el-table-column>
        </el-table>
      </div>
      <!-- 按钮组 -->
      <div class="btns">
        <el-button type="primary" size="small" @click="save" v-if="openType === 'add'">保存</el-button>
        <div v-if="status === 1">
          <el-button type="primary" size="small" v-if="openType === 'edit'" :loading="actionLoading" @click="pass">通过初核
          </el-button>
          <el-button type="danger" size="small" v-if="openType === 'edit'" @click="noPass">不予受理</el-button>
        </div>
        <div v-if="status === 2">
          <el-button type="primary" size="small" v-if="openType === 'edit'" :loading="actionLoading" @click="pass">通过受理
          </el-button>
          <el-button type="danger" size="small" v-if="openType === 'edit'" @click="noPass">不予受理</el-button>
        </div>
        <div v-if="status === 3">
          <el-button type="primary" size="small" v-if="openType === 'edit'" :loading="actionLoading" @click="pass">通过审查
          </el-button>
          <el-button type="danger" size="small" v-if="openType === 'edit'" @click="noPass">不予受理</el-button>
        </div>
        <div v-if="status === 4">
          <el-button type="primary" size="small" v-if="openType === 'edit'" :loading="actionLoading" @click="pass">通过审批
          </el-button>
        </div>
        <div v-if="status === -2">
          <el-button type="primary" size="small" v-if="openType === 'edit'" :loading="actionLoading"
            @click="openCreateDoc">拟定证书</el-button>
        </div>
        <div v-if="status === 5">
          <el-button type="primary" size="small" v-if="openType === 'edit'" :loading="actionLoading" @click="makeCre">制证
          </el-button>
        </div>
        <div v-if="status === 6">
          <el-button type="primary" size="small" v-if="openType === 'edit'" :loading="actionLoading"
            @click="sendCreFormShow">发证</el-button>
        </div>
      </div>
    </div>

    <!-- 公证信息表单 -->
    <NotarizationForm :openType="notarizationFormOpenType" ref="notarizationForm" />
    <!-- 当事人表单(个人) -->
    <PartyForm :openType="partyFormOpenType" :currPartyIndex="currPartyIndex" ref="partyForm" :contractId="contractId"
      :parentOpenType="openType" />
    <!-- 当事人表单(企业) -->
    <PartyFormCompany :openType="partyFormOpenType" :currPartyIndex="currPartyIndex" ref="partyFormCompany"
      :contractId="contractId" :parentOpenType="openType" />
    <!-- 公证事项表单 -->
    <!-- <MattersForm :openType="mattersFormOpenType" ref="mattersForm"/> -->
    <!-- 资料上传 -->
    <DocUploadFrom ref="docUploadFrom" :contractId="contractId" :openType="openType"
      @fevent="getCaseDetails(contractId)" />
    <!-- 拟定证书 -->
    <CreateDoc ref="createDoc" :btnLoading="btnLoading" @save="docSave" />
    <!-- 发证表单 -->
    <SendCreForm @sendCre="sendCre" ref="SendCreForm" />
    <!-- 打印材料 -->
    <PrintFile ref="printFile" :openType="openType" />
    <!-- 批量下载 -->
    <DownLoadsFrom ref="downLoadsFrom"></DownLoadsFrom>
  </el-dialog>
</template>

<script>
import PartyForm from "./form/party-form";
import PartyFormCompany from "./form/party-form-company.vue";
import NotarizationForm from "./form/notarization-form";
import MattersForm from "./form/matters-form";
import FristExamine from "./dialog/frist-examine-dialog.vue";
import eventVue from "./event.js";
import FileList from "../../../components/flie-list.vue";
import DocUploadFrom from './form/docUpload-form';
import { mapGetters } from "vuex";
import { myConfirm, conVertDate } from "@/utils/tools.js";
import CaseInfoFormAdd from "./form/case-info-form";
import CreateDoc from './dialog/create-document-dialog';
import SendCreForm from './dialog/sendCreForm';
import FlieListNodelete from '../../../components/flie-list-nodelete.vue';
import PrintFile from './form/printfile.vue';
import DownLoadsFrom from './form/downloads-form.vue';
export default {
  props: {
    openType: {
      type: String,
      required: true
    },
    currCaseId: {
      required: true
    }
  },
  components: {
    PartyForm,
    PartyFormCompany,
    NotarizationForm,
    MattersForm,
    DocUploadFrom,
    FristExamine,
    FileList,
    CaseInfoFormAdd,
    CreateDoc,
    SendCreForm,
    FlieListNodelete,
    PrintFile,
    DownLoadsFrom,
  },
  data() {
    return {
      visible: false,
      title: '',
      disabled: false, // 是否可编辑（修改）
      showAddBtn: false, // 是否现在新增按钮
      // 公证信息相关参数
      notarizationFormOpenType: "see", // 公证信息表单打开类型(添加,编辑,查看)
      // 当事人相关参数
      partyFormOpenType: "see", // 公证信息表单打开类型(添加,编辑,查看)
      // 公证事项相关参数
      mattersFormOpenType: "see", // 公证信息表单打开类型(添加,编辑,查看)
      currPartyIndex: null,// 编辑的是第几个当时人
      status: -3,// 当前状态
      loading: false,
      docContent: '',
      btnLoading: false,
      actionLoading: false,
      contractId: '',
      detaildTempId: '', // 详情中的模版id
      workFlowList: [],
      printfiles: [],
      notaryNO: '',
      filesList: [],
      downType: '',
    }
  },
  computed: {
    ...mapGetters({
      storeCaseInfo: "case/caseInfo", // 公证事项
      storePersonList: "case/personList", // 当事人(个人)
      storeCompanyList: "case/companyList", // 当事人(公司)
      notaryDocumentList: "case/notaryDocumentList", // 证据材料
      gzItems: "enum/gzItems", // 公证事项
      notarys: "enum/notarys", // 公证员
      templateId: 'makeCard/templateId', // 模板id
    }),
    notarizationTableData() {
      let temData = JSON.parse(JSON.stringify(this.storeCaseInfo));
      // 类别
      switch (temData.lb) {
        case 0:
          temData.lb_name = '合同公证'
          break;
        case 1:
          temData.lb_name = '电子存证'
          break;
        case 2:
          temData.lb_name = '赋强公证'
          break;
        default:
          break;
      }
      // 类型
      switch (temData.lx) {
        case 0:
          temData.lx_name = '借款合同'
          break;
        default:
          break;
      }
      this.gzItems.forEach(item => {
        if (item.value == temData.notaryItem) {
          temData.notaryItem_name = item.label;
          // console.log()
        }
      })
      // 紧急度
      switch (temData.priority) {
        case 0:
          temData.priority_name = '普通'
          break;
        case 1:
          temData.priority_name = '加急'
          break;
        default:
          break;
      }

      let rd;
      if (JSON.stringify(this.storeCaseInfo) === '{}') {
        rd = [];
      } else {
        rd = [temData];
      };
      return rd
    },
    newWorkFlowList() {
      let temData = [...this.workFlowList];
      temData.map(item => {
        // item.createTime = conVertDate(item.createTime);
        console.log('item的数据为：', item)
        switch (item.businessStatus) {
          case null:
            item.status_name = '发起'
            break;
          case -2:
            item.status_name = '拟定公证书'
            break;
          case -1:
            item.status_name = '不予受理'
            break;
          case 1:
            item.status_name = '初核'
            break;
          case 2:
            item.status_name = '受理'
            break;
          case 3:
            item.status_name = '审查'
            break;
          case 4:
            item.status_name = '审批'
            break;
          case 5:
            item.status_name = '制证'
            break;
          case 6:
            item.status_name = '发证'
            break;
          case 7:
            item.status_name = '归档'
            break;
          case 8:
            item.status_name = '收费'
            break;
          case 9:
            item.status_name = "出证"
            break;
          case 10:
            item.status_name = '核实函'
            break;
          case 11:
            item.status_name = '执行证书'
            break;

          default:
            break;
        }
        switch (item.status) {
          case 0:
            item.agree = '是'
            break;
          case 1:
            item.agree = '否'
            break;
          default:
            break;
        }
      })
      return temData;
    }
  },
  created() {

  },
  mounted() {
    this.$store.dispatch('enum/updateGzItems'); // 更新公证员
    this.$store.dispatch('enum/updateNotarys'); // 更新公证事项
    eventBus.$on('checkSuccess', () => {
      this.close();
    })
  },
  watch: {
    openType: {
      immediate: true,
      handler(newValue) {
        switch (newValue) {
          case "see":
            this.title = "查看案件";
            // this.showAddBtn = false;
            this.disabled = true;
            break;
          case "add":
            this.title = "新增案件";
            this.showAddBtn = true;
            this.disabled = false;
            this.workFlowList = [];
            break;
          case "edit":
            this.title = "案件详情";
            this.disabled = false;
            break;
          default:
            this.showAddBtn = false;
            break;
        }
      }
    },
  },
  methods: {

    /**
      * 回到顶部功能实现过程：
      * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
      * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
      * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
      * 4. 最后记得在移动到顶部时，清除定时器
    */
    backtop() {
      var timer = setInterval(function () {
        let osTop = document.getElementsByClassName('el-dialog__wrapper')[6].scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.getElementsByClassName('el-dialog__wrapper')[6].scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30)
    },
    // 打开公证信息弹窗层
    openNotarizationForm(type) {
      this.notarizationFormOpenType = type || '';
      this.$refs.notarizationForm.open();
      console.log(this.storeCaseInfo, this.notarizationTableData);
    },
    // 打开当事人弹窗层
    openPartyForm(type, index) {
      console.log(index);
      this.partyFormOpenType = type || '';
      this.$refs.partyForm.open(type, index);
    },
    // 打开当事人弹窗层
    openPartyFormCompany(type, index) {
      console.log(index);
      this.partyFormOpenType = type || '';
      this.$refs.partyFormCompany.open(type, index);
    },
    // 打开文件上传弹窗
    openDocUpload() {
      this.$refs.docUploadFrom.open();
    },
    //打开打印列表弹窗
    openprint() {
      this.printfiles = [];
      this.notaryDocumentList.forEach(item => {
        if (item.type != 8 && item.type != 6) {
          console.log("运行了此方法")
          this.printfiles.push(item);
        }
      })
      this.$refs.printFile.open(this.printfiles);

    },

    opendown(fileList, type) {
      this.downloadFiles = [];
      this.downType = '';
      this.filesList = fileList;
      this.downType = type;
      this.filesList.forEach(item => {
        if (item.type != 8) {
          this.downloadFiles.push(item);
        }
      })
      this.$refs.downLoadsFrom.open(this.downloadFiles, this.contractId, this.downType);
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    // 初审
    onFristExamine() {
      eventVue.$emit('openFristExamine');
    },
    // 打开证据材料
    openEvidence() {
      eventVue.$emit('openEvidence');
    },
    // 删除证件材料
    deleteItemNotDoc(index) {
      myConfirm({
        text: "是否确认该文件？",
        success: () => {
          this.$store.commit('case/deleteItemNotDoc', index);
        }
      });
    },
    // 删除当事人
    deleteParty(id, index) {
      myConfirm({
        text: "是否确认该当事人？",
        success: () => {
          if (this.openType === 'add') {
            this.$store.commit('case/deleteItemPerson', index);
          } else {
            this.$api.removePerson(id).then(res => {
              if (res.data.code === '200') {
                this.$store.commit('case/deleteItemPerson', index);
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }
        }
      });
    },
    // 保存按钮
    async save() {
      if (this.storePersonList.length === 0) {
        this.$message({
          message: '请添加当事人',
          type: 'warning'
        });
        return;
      }
      if (this.notaryDocumentList.length === 0) {
        this.$message({
          message: '请添加证件资料',
          type: 'warning'
        });
        return;
      }

      let res = await this.$refs.caseInfoFormAdd.submitForm();

      if (!res) {
        return;
      }

      let obj = { ...this.storeCaseInfo };
      obj.personList = this.storePersonList;
      obj.notaryDocumentList = this.notaryDocumentList;
      let dsr = this.storePersonList.map(item => {
        return item.name;
      });
      obj.dsr = dsr.join(',');
      console.log(obj);
      // 新增案件
      this.$api.createCase(obj).then(res => {
        if (res.data.code === '200') {
          this.$store.commit('case/updateCaseInfo', {}); // 清空公证信息
          this.$store.commit('case/clearPersonList'); // 清空当事人
          this.$store.commit('case/clearNotaryDocumentList'); // 清空证件资料
          // 向父组件发送，成功事件
          this.$emit('createSuccess');
          // 关闭弹窗
          this.close();
          // 消息提示
          this.$message({
            message: '添加成功',
            type: 'success'
          });
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    // 根据id获取案件详情
    getCaseDetails(id) {
      if (!id) {
        return;
      }
      this.contractId = id.toString();
      this.loading = true;
      this.$api.getCaseDetails(id).then(res => {
        if (res.data.code === '200') {
          // 更新案件信息
          this.status = res.data.data.status;
          this.detaildTempId = res.data.data.templateId;
          this.workFlowList = res.data.data.contractWorkFlowList;

          if (this.status >= 5) {
            this.disabled = true;
            this.showAddBtn = false;
          } else {
            this.disabled = true;
            this.showAddBtn = true;
          }
          this.$store.commit('case/updateCaseInfo', {
            charge: res.data.data.charge, // 公证费用
            lb: res.data.data.lb, // 类别
            lx: res.data.data.lx, // 类型
            notaryItem: res.data.data.notaryItem, // 公证事项，传公证事项下来的id
            notaryId: res.data.data.notaryId, // 公证员编码
            notaryName: res.data.data.notaryName, // 公证员姓名
            priority: res.data.data.priority, // 紧急度
            acceptDate: res.data.data.acceptDate, // 日期
            applyDate: res.data.data.applyDate, // 申请日期
            notaryNo: res.data.data.notaryNo, // 卷宗号
            contractId: res.data.data.id, // 卷宗id
          });

          // 更新当事人(个人)
          if (res.data.data.personList) {
            this.$store.commit('case/updatePersonList', res.data.data.personList);
          } else {
            this.$store.commit('case/updatePersonList', []);
          }
          console.log('companyList', res.data.data.companyList, !!res.data.data.companyList);
          // 更新当事人(公司)
          if (!!res.data.data.companyList) {
            this.$store.commit('case/updateCompanyList', res.data.data.companyList);
          } else {
            this.$store.commit('case/updateCompanyList', []);
          }

          // 更新材料
          if (res.data.data.notaryDocumentList) {

            this.$store.commit('case/updateNotaryDocumentList', res.data.data.notaryDocumentList);
          } else {
            this.$store.commit('case/updateNotaryDocumentList', []);
          }

          // 更新是否设置了盖章密码
          this.$store.commit('makeCard/updateIssuePassword', res.data.data.issuePassword);
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    // 通过
    async pass() {
      let res = await this.$refs.caseInfoFormAdd.submitForm();

      if (!res) {
        this.backtop();
        return;
      }
      this.actionLoading = true;

      let reqData = {
        notaryId: this.storeCaseInfo.notaryId,
        owner: this.storeCaseInfo.owner,
        contractId: this.currCaseId,
        approverStatus: 0
      };
      // console.log(reqData);

      // 通过
      let request;
      switch (this.status) {
        case 1:
          request = this.$api.chuhe // 初核
          break;
        case 2:
          request = this.$api.shouli // 受理
          break;
        case 3:
          request = this.$api.shencha // 审查
          break;
        case 4:
          request = this.$api.shenpi // 审批
          break;
        case -2:
          request = this.$api.nici // 拟定公证词
          reqData.content = this.docContent;
          reqData.templateId = this.templateId;
          this.btnLoading = true;
          break;
        default:
          break;
      }
      request(reqData).then(res => {
        if (res.data.code === '200') {
          this.$message({
            message: '提交成功',
            type: 'success'
          });
          this.close();
          this.$refs.createDoc.close();
          this.$emit('checkSuccess');
          // 重置（顶部）表单
          this.$refs.caseInfoFormAdd.resetForm();
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          });
        }
      }).finally(() => {
        this.btnLoading = false;
        this.actionLoading = false;
      })
    },
    // 不予受理
    noPass() {
      this.$emit("noPass", this.currCaseId, this.status);
    },
    
    // 拟定证书
    async openCreateDoc() {
      let res = await this.$refs.caseInfoFormAdd.submitForm();

      if (!res) {
        this.backtop();
        return;
      }

      this.$refs.createDoc.open();
    },
    // 提交公证书
    docSave(content) {
      this.docContent = content;
      this.pass();
    },
    // 判断是否有签名
    async checkCustNo() {
      return this.$api.checkCustNo();
    },
    // 制证
    async makeCre() {
      // 先判断有没有公章
      let result = await this.checkCustNo();
      if (result.data.code !== '200') {
        this.$alert('您还没有设置签名，请到用户列表设置签名，或联系管理员设置签名。', '提示', {
          confirmButtonText: '确定',
          callback: action => { }
        });
        return;
      }

      let res = await this.$refs.caseInfoFormAdd.submitForm();

      if (!res) {
        this.backtop();
        return;
      }

      let reqData = {
        notaryId: this.storeCaseInfo.notaryId,
        owner: this.storeCaseInfo.owner,
        contractId: this.currCaseId,
        approverStatus: 0
      };
      console.log(reqData);
      this.$store.commit('makeCard/updateMakeCardReqData', reqData);
      this.$router.push({
        path: '/business/sign',
        query: {
          detaildTempId: this.detaildTempId
        }
      });
    },
    sendCreFormShow() {
      this.$refs.SendCreForm.open();
    },
    // 发证
    async sendCre(contractIssueList) {
      let res = await this.$refs.caseInfoFormAdd.submitForm();

      if (!res) {
        this.backtop();
        return;
      }

      let reqData = {
        notaryId: this.storeCaseInfo.notaryId,
        owner: this.storeCaseInfo.owner,
        contractId: this.currCaseId,
        approverStatus: 0
      };
      reqData.contractIssueList = contractIssueList;


      this.$api.fazheng(reqData).then(res => {
        if (res.data.code === '200') {
          this.$message({
            message: '发证成功',
            type: 'success'
          });
          this.close();
          this.$refs.createDoc.close();
          this.$emit('checkSuccess');
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          });
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../style/mixin";

.info-item {
  .header {
    margin: 30px 0 10px;
    font-size: 16px;
    .flex(space-between);
  }

  &:nth-child(1) {
    .header {
      margin-top: 0;
    }
  }
}

.btns {
  margin-top: 20px;
  .flex(flex-end);
}
</style>
